module.exports = new __parcel__URL__("AudioBriefingErrorIllustration.60778c34.svg").toString();